import styles from './Loader.module.less';

interface LoaderProps {
  fullscreen?: boolean;
}

export function Loader({ fullscreen = false }: LoaderProps) {
  return (
    <div className={fullscreen ? styles.fullscreen : styles.container}>
      <div className={styles.spinner} />
    </div>
  );
}
